import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ConfigService } from '../services/config.service';

export const xsrfInterceptor: HttpInterceptorFn = (req, next) => {
    const configService = inject(ConfigService);

    const token = configService.configState().store?.xsrfToken ?? null;

    const modifiedRequest = token ? req.clone({ setHeaders: { 'X-XSRF-TOKEN': token } }) : req;

    return next(modifiedRequest);
};
